import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";

const IndentNoteViewSingle = () => {
  useAuthRedirect();
    const {indentNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [indentView, setIndentView] = useState({});
  const [data, setData] = useState([]);

  const canView = hasPermission("Store Requisition", "view");
  const canVehicle = hasPermission("Hire Vehicle Registration", "entry");

  const showSwalLoader = (titleText = "Loading...") => {
  Swal.fire({
    title: titleText,
    html: `
      <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
        <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
      </div>
      <p style="margin-top: 10px; font-size: 14px;">Please wait...</p>
    `,
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      if (!document.getElementById("progressBarStyle")) {
        const style = document.createElement("style");
        style.id = "progressBarStyle";
        style.innerHTML = `
          @keyframes progressBar {
            0% { width: 0% }
            50% { width: 100% }
            100% { width: 0% }
          }
        `;
        document.head.appendChild(style);
      }
    }
  });
};



  useEffect(() => {
  const fetchIndentDetails = async () => {
    showSwalLoader("Fetching Indent Header...");

    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/storeReq_detailsHeader?indentNo=${indentNo}&branch=${branch}`);
      if (response.data && response.data.headerDetails?.length > 0) {
        const items = response.data.headerDetails;

        const storeReqHeader = {
          indentDate: items[0].indentHeader_date || "N/A",
          dept: items[0].departmentmaster_name || "N/A",
          supervisor: items[0].indentHeader_supervisorcode || "N/A",
          remarks: items[0].indentHeader_remarks || "N/A",
        };

        setIndentView(storeReqHeader);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    } finally {
      Swal.close(); // Close the progress bar
    }
  };

  fetchIndentDetails();
}, [indentNo, branch]);


useEffect(() => {
  showSwalLoader("Fetching Indent Details...");

  axios.get(`https://rfs2.infraconsoft.net.in/api/storeReq_bottomDetails?indentNo=${indentNo}&branch=${branch}`)
    .then((response) => {
      setData(response.data.bottomDetails);
      console.log(response.data.bottomDetails);
    })
    .catch((error) => {
      console.error("Error fetching vehicles:", error);
    })
    .finally(() => {
      Swal.close(); // Close the progress bar
    });
}, [indentNo, branch]);

if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
          <h2 className="add-txt">Stores Requisition Note - View</h2>
          <Link to='/inventory/indentNoteView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>Indent No :</label>
                <input type="text" name="indentNo" value={indentNo} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
  type="text"
  name="endhrs"
  value={indentView.indentDate ? new Date(indentView.indentDate).toISOString().split("T")[0] : ""}
 readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Department :</label>
                <input type="text" name="indentNo" value={indentView.dept} readOnly/>
              </div>
              <div className="form-group">
                <label>Supervisor Code :</label>
                <input type="text" value={indentView.supervisor} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={indentView.remarks} name="remarks" readOnly />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden" />
              </div>
            </div>


            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Qty</th>
                     {canVehicle && (
                      <>
                    <th>Vehicle Code</th>
                    <th>Vehicle Number</th>
                    </>
                     )}
                    <th>Due Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.indentDetail_itemCode}</td>
                        <td>{item.itemmaster_name}</td>
                        <td>{item.itemmaster_drawingNumber}</td>
                        <td>{item.itemmaster_uom}</td>
                        <td>{item.indentDetail_quantity}</td>
                        {canVehicle && (
                          <>
                        <td>{item.indentDetaill_VehicleCode}</td>
                        <td>{item.indentDetaill_VehicleNumber}</td>
                        </>
                        )}
                        <td>{new Date(item.indentDetail_dueDate).toLocaleDateString("en-GB")}</td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default IndentNoteViewSingle;
